<template>
    <table class="table table-striped table-hover table-responsive-md text-center">
        <thead>
            <tr>
                <th>{{ $t("patrolLog.patrolRoute") }}</th>
                <th>{{ $t("patrolLog.deviceName") }}</th>
                <th>{{ $t("patrolLog.startedAt") }}</th>
                <th>{{ $t("patrolLog.finishedAt") }}</th>
                <th>{{ $t("patrolLog.duration") }}</th>
                <th></th>
            </tr>
        </thead>
        <tbody v-if="patrolLogs.length">
            <tr
                v-for="log in paginatedLogs"
                :key="log.id"
                class="align-middle"
            >
                <td>{{ log.patrol_route_name }}</td>
                <td>{{ log.device_name }}</td>
                <td>{{ log.started_at ? $d(new Date(log.started_at), "short") : "--" }}</td>
                <td>{{ log.finished_at ? $d(new Date(log.finished_at), "short") : $t("patrolLog.inProgress") }}</td>
                <td>{{ log.duration === 0 ? "--" : log.duration }}</td>
                <td>
                    <button
                        class="btn btn-primary btn-sm me-2"
                        @click="goTo(log.id)"
                    >
                        <icon icon="Search"></icon>
                    </button>
                    <button
                        v-if="$store.getters.hasGatehousePerm('delete_patrollog')"
                        class="btn btn-danger btn-sm"
                        @click.stop="deletePatrolLog(log.id)"
                    >
                        <icon icon="Trash"></icon>
                    </button>
                </td>
            </tr>
        </tbody>
        <tbody v-else>
            <tr>
                <td colspan="6" class="text-center text-muted py-3">
                    {{ $t("patrolLog.notFound") }}
                </td>
            </tr>
        </tbody>
    </table>
    <div v-if="patrolLogs.length >= 5" class="d-flex justify-content-between mx-4">
        <Paginate
            :page-count="totalPages"
            :click-handler="(p) => currentPage = p"
            :prev-text="'«'"
            :next-text="'»'"
            :container-class="'pagination'"
            :page-class="'page-item'"
            :page-link-class="'page-link'"
            :active-class="'active'"
            :disabled-class="'disabled'"
        />
        <div class="flex-shrink-0">
            <select v-model="perPage" class="form-select form-select-sm" style="height: 40px;">
                <option :value="5">5</option>
                <option :value="10">10</option>
                <option :value="25">20</option>
                <option :value="50">50</option>
            </select>
        </div>
    </div>
</template>

<script>
import Icon from '@/components/Icon.vue';
import { goToDetail, deleteItem } from '@/utils/actions';
import Paginate from 'vuejs-paginate-next';

export default {
    components: {
        Icon,
        Paginate,
    },
    props: {
        patrolLogs: {
            type: Array,
            default: () => []
        },
        success: {
            type: Function,
        },
    },
    data() {
        return {
            currentPage: 1,
            perPage: 10,
        }
    },
    computed: {
        paginatedLogs() {
            const start = (this.currentPage - 1) * this.perPage;
            return this.patrolLogs.slice(start, start + this.perPage);
        },
        totalPages() {
            return Math.ceil(this.patrolLogs.length / this.perPage);
        }
    },
    methods: {
        goTo(logId) {
            goToDetail({
                router: this.$router,
                routeName: "PatrolLogDetailView",
                slug: this.$route.params.slug,
                id: logId,
            });
        },
        deletePatrolLog(logId) {
            deleteItem({
                api: this.$store.getters.api,
                slug: this.$route.params.slug,
                model: "patrol-logs",
                id: logId,
                confirmMessage: this.$t("patrolLog.delete"),
                successCallback: this.success,
            });
        }
    }
}
</script>